import React, { useEffect, useState } from "react";
import { Card, Table, Space, Button, Input } from "antd";
import { useQuery } from "@apollo/react-hooks";
import { FindStudents } from "../../graphql/organization";
import { UserLink } from "../UserLink/UserLink";

export const StudentsCard = ({ orgId, style }) => {
  const [kw, setKw] = useState("");

  const { loading, data: { students } = { students: [] }, refetch } = useQuery<any>(FindStudents, {
    variables: { orgId },
  });

  const members = students.filter((m) => {
    return (
      m.firstName?.toLowerCase()?.includes(kw.toLowerCase()) || m.lastName?.toLowerCase()?.includes(kw.toLowerCase())
    );
  });

  useEffect(() => {
    refetch();
  }, []);

  const columns = [
    { title: "", key: "i", render: (t, r, i) => i + 1 },
    {
      title: "First Name/Initial",
      dataIndex: "firstName",
      key: "firstName",
      sorter: (a, b) => a.firstName?.localeCompare(b.firstName),
      render: (_, r) => <UserLink childId={r.childId} name={r.firstName} />,
    },
    // {
    //   title: "Last Name",
    //   dataIndex: "lastName",
    //   key: "lastName",
    //   sorter: (a, b) => a.lastName?.localeCompare(b.lastName),
    //   render: (_, r) => <UserLink childId={r.childId} name={r.lastName} />,
    // },
    {
      title: "Grade",
      dataIndex: "grade",
      sorter: (a, b) => a.grade?.localeCompare(b.grade),
      key: "grade",
    },
    // {
    //   title: "Parent",
    //   dataIndex: ["parent", "name"],
    //   key: "userName",
    // },
  ];

  return (
    <Card
      extra={
        <Space>
          <Button size="small" onClick={() => refetch()}>
            Refresh
          </Button>
          <Input.Search size="small" value={kw} onChange={(e) => setKw(e.target.value)} />
        </Space>
      }
      size="small"
      style={style}
      bodyStyle={{ padding: 0 }}
    >
      <Table
        size="small"
        pagination={{ pageSize: 1500, pageSizeOptions: ["1500"] }}
        loading={loading}
        rowKey="childId"
        columns={columns}
        dataSource={members}
      />
    </Card>
  );
};
